import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext(null);

/**
 * Reads the effective theme:
 *   1. localStorage override if present
 *   2. system preference otherwise
 */
function getInitialTheme() {
  // Always default to light theme as per lead's request
  return 'light';
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const t = getInitialTheme();
    applyTheme(t);
    return t;
  });

  // Listen to system preference changes (Disabled for now)
  useEffect(() => {
    // const mq = window.matchMedia('(prefers-color-scheme: dark)');
    // const handler = (e) => {
    //   if (!localStorage.getItem('pms-theme')) {
    //     const next = e.matches ? 'dark' : 'light';
    //     applyTheme(next);
    //     setTheme(next);
    //   }
    // };
    // mq.addEventListener('change', handler);
    // return () => mq.removeEventListener('change', handler);
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      applyTheme(next);
      localStorage.setItem('pms-theme', next);
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}
